<template>
  <el-dialog
    class="radish-dia"
    title="修改"
    top="70px"
    :modal="false"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <div v-if="dialogVisible" class="radish-dia-body">
      <div v-if="cates.length > 0">
        所属职能模块：
        <el-select v-model="cate" size="mini" filterable placeholder="选择职能模块" @change="handleChangeCate">
          <el-option v-for="(v, k) in cates" :key="k" :label="v" :value="v"></el-option>
        </el-select>
      </div>
      <div v-if="comment" style="color:red">
        错误原因：{{ comment }}
        <div
          v-if="
            (head.label === '细分职能' && comment === '必须有职能模块才有细分职能') ||
              (head.label === '擅长方向' && comment === '必须有职能模块才有擅长方向')
          "
          class="radish-btn radish-btn-primary"
          @click="show({ rows, label: '职能模块', value: [], comment })"
        >
          点击此处添加职能模块
        </div>
        <span
          v-else-if="
            val instanceof Array &&
              val.length > 0 &&
              !['必须有职能模块才有细分职能', '必须有职能模块才有擅长方向'].includes(comment)
          "
        >
          (请点击 <i class="el-icon-circle-close"></i> 删除错误的项并选择正确的项)
        </span>
      </div>
      <formItem
        :type="head.editType"
        :is-inline="true"
        :no-label="true"
        label-width="0"
        :label="head.label"
        :options="head.options"
        :content="val"
        :handle-data-change="handleChangeVal"
        :remove-tag="handleRemoveTag"
        :handle-focus="handleFocus"
      ></formItem>
      <div v-if="isOtherShow">其他：<el-input v-model="rows[0]['其他']" size="mini" /></div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button size="mini" @click="dialogVisible = false">取 消</el-button>
      <el-button size="mini" type="primary" @click="handleConfirm">{{
        head.label === '职能模块' ? '确定添加' : '确 定'
      }}</el-button>
    </span>
  </el-dialog>
</template>
<script>
import editHeads from './edit-heads.js'

export default {
  mixins: [editHeads],
  props: {
    onConfirm: {
      type: Function,
      default: function() {},
    },
    onRemoveTag: {
      type: Function,
      default: function() {},
    },
  },
  data: function() {
    return {
      dialogVisible: false,
      rows: [],
      cates: [],
      head: {},
      val: '',
      cate: '',
      comment: '',
      commonVal: [],
      isOtherShow: false,
    }
  },
  methods: {
    show: function(params) {
      const { rows, label, value, comment } = params
      this.val = value || ''
      this.comment = comment || ''
      this.cates = []
      this.cate = ''
      this.commonVal = []
      this.head = this.heads.filter(h => h.label === label)[0]
      this.rows = rows
      if (value && label === '手机') {
        this.isOtherShow = true
      } else {
        this.isOtherShow = false
      }
      this.handleXiShan()
      this.dialogVisible = true
    },
    handleConfirm: async function() {
      const label = this.head.field || this.head.label
      const val = this.val
      if (this.head.label == '细分职能' || this.head.label == '擅长方向') {
        if (!this.cate) {
          return this.$message.error('请选择职能模块')
        }
        await this.onConfirm({ rows: this.rows, label, value: val })
      } else {
        await this.onConfirm({ rows: this.rows, label, value: val })
      }
      this.dialogVisible = false
    },
    handleXiShan: async function() {
      let cates = []
      const commonObj = {}
      const commonVal = []
      if (this.head.label == '职能模块') {
        if (!app.categories) {
          await app.getCats()
        }
        this.head.options = app.categories.map(cat => cat['名称'])
        this.rows.forEach(row => {
          // 共有职能模块
          if (row[this.head.label]) {
            row[this.head.label].forEach(x => {
              commonObj[x] = commonObj[x] ? commonObj[x] + 1 : 1
            })
          }
        })
        for (const x in commonObj) {
          if (commonObj[x] == this.rows.length) {
            commonVal.push(x)
          }
        }
        this.val = [].concat(commonVal)
        this.commonVal = commonVal
      } else if (this.head.label == '细分职能' || this.head.label == '擅长方向') {
        this.rows.forEach(row => {
          // 职能模块选项
          if (row['职能模块']) {
            cates = cates.concat(row['职能模块'])
          }
          // 共有细分职能擅长方向
          if (row[this.head.label]) {
            row[this.head.label].forEach(x => {
              commonObj[x] = commonObj[x] ? commonObj[x] + 1 : 1
            })
          }
        })
        this.cates = Array.from(new Set(cates))
        for (const x in commonObj) {
          if (commonObj[x] == this.rows.length) {
            commonVal.push(x)
          }
        }
        if (this.cates.length === 1) {
          this.cate = this.cates[0]
          this.handleChangeCate()
        }
        this.val = [].concat(commonVal)
        this.commonVal = commonVal
      }
    },
    handleChangeCate: async function() {
      if (!app.categories) {
        await app.getCats()
      }
      const catData = app.categories
      const currentCat = catData.filter(cat => this.cate == cat['名称'])
      // console.log(currentCat)
      if (this.head.label == '细分职能') {
        this.head.options = currentCat[0]['二级职能'] || []
      } else if (this.head.label == '擅长方向') {
        this.head.options = currentCat[0]['擅长方向'] || []
      }
    },
    handleChangeVal: function(res) {
      const { content } = res
      this.val = content
    },
    handleRemoveTag: async function(res) {
      // console.log(this.commonVal)
      const { label, tag } = res
      if (this.commonVal.includes(tag)) {
        await this.onRemoveTag({ rows: this.rows, label, tag })
        // this.dialogVisible = false
      }
    },
    handleFocus: function(label) {
      if ((this.head.label == '细分职能' || this.head.label == '擅长方向') && !this.cate) {
        return this.$message.error('请先选择职能模块 啊!!!!')
      }
    },
  },
}
</script>
